import { useAuthStore } from "~/store/auth";
import { useUserStore } from "~/store/user";

export default defineNuxtRouteMiddleware((to) => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const localePath = useLocalePath();

  const LOGIN_PAGE = "/login";
  const PASSWORD_RESET_PAGE = "/public/password-reset";

  if (authStore.isAuthenticated && authStore.user && !userStore.user) {
    userStore.user = authStore.user;
  }

  const loginPath = localePath(LOGIN_PAGE);
  const passwordResetPath = localePath(PASSWORD_RESET_PAGE);
  const publicPaths = [loginPath, passwordResetPath];

  const isPublicRoute =
    publicPaths.includes(to.path) ||
    to.path.includes("/password-reset/confirm/");

  if (!authStore.isAuthenticated) {
    if (!isPublicRoute) {
      return navigateTo(loginPath);
    }
    return;
  }

  if (authStore.isAuthenticated && to.path === loginPath) {
    return navigateTo(localePath("/"));
  }
  return;
});
